import React from "react";
import { Link } from "react-router-dom";

const ProductCard = ({ product }) => {
  return (
    <article className="website-product-card">

      {/* =====================================================
          IMAGE
      ===================================================== */}

      <div className="product-card-image">

        {product.image?.url ? (
          <img
            src={product.image.url}
            alt={
              product.image.altText ||
              product.name ||
              "Product"
            }
          />
        ) : (
          <div className="product-card-placeholder">
            <span>
              {product.name?.charAt(0)?.toUpperCase() || "P"}
            </span>
          </div>
        )}

        <div className="product-card-image-overlay" />

      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="product-card-content">

        <div className="product-card-top">

          {product.category?.name && (
            <span className="product-card-category">
              {product.category.name}
            </span>
          )}

          <span className="product-card-number">
            →
          </span>

        </div>


        <h3>
          {product.name}
        </h3>


        {product.shortDescription && (
          <p>
            {product.shortDescription}
          </p>
        )}


        <div className="product-card-bottom">

          <Link
            to={`/products/${product.slug}`}
            className="product-card-link"
          >
            <span>
              View Details
            </span>

            <span className="product-card-link-arrow">
              →
            </span>
          </Link>

        </div>

      </div>

    </article>
  );
};

export default ProductCard;